import styled from 'styled-components';

export const LogosContainer = styled.div`
  display: flex;
  gap: 5px;
  flex-shrink: 0;
`

export const LogoWrapper = styled.div`
  padding: 0;
  position: relative;
  top: ${({ top }) => top};
  transition: all 0.5s ease 0s;
  max-height: 40px;
`